import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useState } from "react";

import backgroundimage from "../../assets/Background1.png";
import personImage from "../../assets/PersonImage.png";
import Navbar from "../../Components/Layout/Navbar";

const HeaderSection = () => {
  const title = "Mr. Sailesh Dani";

  const paragraph =
    "Sailesh Dani is a visionary professional known for his innovative approaches and groundbreaking contributions across multiple domains, including infrastructure, education, crematorium systems, and advancements in medical science and technology.";

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: false,
    });
    AOS.refresh();
  }, []);

  const [typedText, setTypedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < paragraph.length) {
      const typingTimer = setTimeout(() => {
        setTypedText((prev) => prev + paragraph[currentIndex]);
        setCurrentIndex((prev) => prev + 1);
      }, 100);

      return () => clearTimeout(typingTimer);
    }
  }, [currentIndex, paragraph]);

  return (
    <div
      className="relative min-h-[90%] w-full flex flex-col justify-between pt-5"
      style={{
        backgroundImage: `url(${backgroundimage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="relative h-full">
        {/* <Navbar /> */}

        <main className="container mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-20 lg:pt-24">
          <div className="flex flex-col items-center lg:flex-row lg:justify-around lg:items-center min-h-[calc(100vh-300px)]">
            {/* Content Section */}
            <div className="w-full lg:w-1/2 text-center lg:text-left order-2 lg:order-1 mt-8 lg:mt-0">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-wide dmsans mb-6">
                {title.split("").map((char, index) => (
                  <span
                    key={index}
                    data-aos="fade-up"
                    data-aos-delay={`${index * 100}`}
                    className="inline-block"
                  >
                    {char === " " ? "\u00A0" : char}
                  </span>
                ))}
              </h1>

              <p
                className="text-white text-sm sm:text-sm md:text-lg lg:text-xl xl:text-2xl max-w-2xl mx-auto lg:mx-0 heebo"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                {typedText}
                <span className="animate-pulse">|</span>
              </p>
            </div>

            {/* Image Section */}
            <div className="order-1 lg:order-2 w-full lg:w-1/2 flex justify-center lg:justify-end">
              <div
                className="w-48 h-48 sm:w-64 sm:h-64 md:w-72 md:h-72 lg:w-96 lg:h-96 rounded-full overflow-hidden border-4 border-gray-700 shadow-lg transform transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:border-[#3FFFCC]"
                data-aos="flip-left"
                data-aos-delay="300"
              >
                <img
                  src={personImage}
                  alt="Mr. Sailesh Dani"
                  className="w-full h-full object-cover hover:opacity-90 brightness-90"
                />
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Bottom Banner */}
      <div className="w-full bg-[#272F3D] py-4 sm:py-5 lg:py-6 sm:mt-12 mt-20">
        <div className="container mx-auto px-4">
          <div
            className="text-center text-[#3FFFCC] text-base sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-semibold tracking-wide sm:tracking-[0.5em] dmsans uppercase"
            // data-aos="zoom-in-up"
            // data-aos-duration="1000"
            // data-aos-delay="200"
          >
            <i>"Managing Director Lingaraj Group"</i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
